// Copyright (c) StrangeBee 2024

import { ActionContent } from '@Organisms/LiveStreamData/Cards/Action/ActionContent';
import { AlertContent } from '@Organisms/LiveStreamData/Cards/Alert/AlertContent';
import { CaseContent } from '@Organisms/LiveStreamData/Cards/Case/CaseContent';
import { JobContent } from '@Organisms/LiveStreamData/Cards/Job/JobContent';
import { ObservableContent } from '@Organisms/LiveStreamData/Cards/Observable/ObservableContent';
import { TaskContent } from '@Organisms/LiveStreamData/Cards/Task/TaskContent';
import { TaskLogContent } from '@Organisms/LiveStreamData/Cards/TaskLog/TaskLogContent';
import { CaseTemplateContent } from '@Organisms/LiveStreamData/Cards/CaseTemplate/CaseTemplateContent';
import { JSXElementConstructor, ReactElement } from 'react';
import { CardContentProps } from './CardContentType';
import { CommentContent } from './Comment/CommentContent';
import { ErrorContent } from './Error/ErrorContent';
import { ProcedureContent } from './Procedure/ProcedureContent';
import { AttachmentContent } from './Attachment/AttachmentContent';
import { PageContent } from './Page/PageContent';
import { CustomEvent } from './CustomEvent/CustomEventContent';
import { DashboardContent } from './Dashboard/DashboardContent';

type CardType = (props: CardContentProps) => ReactElement<any, string | JSXElementConstructor<any>> | null;

const libCards: Record<string, CardType> = {
    //careful with the lowercase comparison in LiveStreamCard
    action: ActionContent,
    alert: AlertContent,
    attachment: AttachmentContent,
    case_artifact_job: JobContent,
    case_artifact: ObservableContent,
    case_task_log: TaskLogContent,
    case_task: TaskContent,
    casetemplate: CaseTemplateContent,
    case: CaseContent,
    comment: CommentContent,
    customevent: CustomEvent,
    error: ErrorContent,
    page: PageContent,
    procedure: ProcedureContent,
    dashboard: DashboardContent,

    // V0->V1
    job: JobContent,
    observable: ObservableContent,
    log: TaskLogContent,
    task: TaskContent,
};

export default libCards;
